import { useSelector } from 'react-redux';
import NotificationsCenter from 'components/NotificationsCenter';
import EmptyNotifications from './EmptyNotifications';
import './styles.scss';

const NotificationWidget = () => {
  const notifications = useSelector(state => state.global.notifications);
  const unreadNotifications = notifications.filter(notification => !notification.isRead);
  return (
    <div className='dashboard--notification notification-center'>
      { unreadNotifications?.length > 0 ?
        (
          <div className='notification-menu'>
            <NotificationsCenter
              contentOnly
              widget
            />
          </div>
        ) : (
          <EmptyNotifications />
        )
      }
    </div>
  );
};

export default NotificationWidget;

